import { useRefGetter } from '../../use';
import { useCallback } from 'react';
export function useContainer(elem) {
  var elemGetter = useRefGetter(elem);
  return useCallback(function () {
    var element = elemGetter();

    if (typeof window === 'undefined') {
      return null;
    }

    if (element == null || element instanceof HTMLElement) {
      return element;
    }

    return element.current;
  }, []);
}